import { IonContent, IonPage } from '@ionic/react'
import { useDispatch } from 'react-redux'
import React from 'react'
import { useTranslation } from 'react-i18next'
import HeaderNav from '../../../components/headerNav/HeaderNav.component'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import { saveSceneDescriptionState } from '../store/sceneDescription.actions'
import { IPHIComponent } from '../../../components/phi/phi.component'
import SceneDescriptionContent from '../content/SceneDescription.content'

const SceneDescription: React.FC<IPHIComponent> = (props: IPHIComponent) => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { t } = useTranslation()

  const onBackClick = () => {
    history.push(TabConstants.CHART_ROUTE)
  }

  const onSaveClick = () => {
    dispatch(saveSceneDescriptionState())
  }

  return (
    <IonPage id='SceneDescriptionPage'>
      <PCRHeader />
      <HeaderNav
        prevOnClick={onBackClick}
        prevLabel={t('common.buttons.Back')}
        isBackButton={true}
        nextLabel={t('common.buttons.Save')}
        nextOnClick={onSaveClick}
        title={t('sceneDescription.sceneDescription')}
      />
      <IonContent color='light'>
        <SceneDescriptionContent />
      </IonContent>
    </IonPage>
  )
}

export default SceneDescription
